import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { AccountService, NDAService, RegistrationService } from '../../../../services';

import { jsPDF } from 'jspdf';
import { combineLatest } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'nda-page',
  styleUrls: ['./nda-page.component.scss'],
  templateUrl: './nda-page.component.pug'
})
export class NdaPage implements OnInit {

  @ViewChild('container', { static: false }) container: ElementRef;
  // @ViewChild('pdfViewer') public pdfViewer;

  public timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  public registration: any;
  public partyMembers: any[] = [];
  public ndas: Array<any> = [];
  public registrantPicture: any;
  public customFields: Array<string>;
  public ndaPdfs: object = {};

  constructor(private registrationService: RegistrationService, private ndaService: NDAService, private accountService: AccountService, private router: Router, private route: ActivatedRoute) {
    let id: number;
    // const TOKEN_KEY = 'access_token';
    // let accessTokenId = this.route.snapshot.queryParams[TOKEN_KEY];
    // console.log(accessTokenId)
    // let accessToken = this.accountService.getAccessToken()
    // accessTokenId = accessToken.id
    // console.log(accessTokenId)

    this.route.params.forEach((params: Params) => {
      const ID_KEY = 'id';
      id = +params[ID_KEY];
    });
    // this.registrationService.getById(id).subscribe((registration) => {
    const getNda = this.registrationService.getNda(id).pipe(
      tap((registration: any) => {
        console.log('registration', registration)
        this.registration = registration;
        this.partyMembers = [
          {
            id: registration.id,
            ndas: registration?.ndaData?.ndaUrls?.map((url) => ({ url })) ?? this.registration.Screening?.NDAs ?? [],
            customFields: registration?.ndaData?.customFields ?? {},
            registrantPicture: registration.registrantPicture || null,
            ndaSignature: registration?.ndaSignature,
            firstName: registration.Account.firstName || 'Registrant',
            lastName: registration.Account.lastName || 1,
            email: registration.Account.email || '',
            phoneNumber: registration.Account.phoneNumber || '',
            isChild: false,
            ndaTimestamp: registration.ndaTimestamp,
            checkedIn: registration.checkedIn,
          },
          ...(registration?.Party?.Registrations ?? []).filter(r => r.id !== registration.id).map((r, i) => {
            return {
              id: r.id,
              ndas: r?.ndaData?.ndaUrls?.map((url) => ({ url })) ?? this.registration.Screening?.NDAs ?? [],
              customFields: r?.ndaData?.customFields ?? {},
              registrantPicture: r.registrantPicture || null,
              ndaSignature: r?.ndaSignature,
              firstName: r.Account.firstName || 'Registrant',
              lastName: r.Account.lastName || i + 1,
              email: r.Account.email || '',
              phoneNumber: r.Account.phoneNumber || '',
              isChild: false,
              ndaTimestamp: r.ndaTimestamp,
              checkedIn: r.checkedIn,
            }
          }),
          ...(registration?.Party?.Kids ?? []).map((kid, i) => {
            const ndaSignedBy = (registration?.Party?.Registrations ?? []).find(r => r.id === kid.ndaSignedBy)?.Account ?? null;
            const AgeValue = kid?.Answer?.find((a) => a.Question.fieldCode === 'Child Age')?.answerJSON?.values ?? [];
            return {
              id: kid.id,
              ndas: kid?.ndaData?.ndaUrls?.map((url) => ({ url })) ?? this.registration.Screening?.MinorNDAs ?? [],
              customFields: kid?.ndaData?.customFields ?? {},
              registrantPicture: kid.registrantPicture || null,
              ndaSignature: kid?.ndaSignature,
              firstName: 'Child',
              lastName: i + 1,
              isChild: true,
              ndaTimestamp: kid.ndaTimestamp,
              ndaSignedBy: ndaSignedBy ? `${ndaSignedBy?.firstName} ${ndaSignedBy?.lastName}` : 'Guardian',
              gender: kid.gender,
              ethnicity: `${kid.ethnicity}${Array.isArray(kid.ethnicities) && kid.ethnicity === 'Multi-Ethnic' ? ` (${kid.ethnicities.join(', ')})` : ''}`,
              age: AgeValue.length ? AgeValue.join(', ') : 'N/A',
            }
          })
        ].filter((r) => r.ndaSignature);

        this.ndas = [...new Set(this.partyMembers.flatMap((pm) => pm.ndas).map((nda) => nda.url))].map((url) => { return { url }; });
        this.customFields = [...new Set(this.partyMembers.flatMap((pm) => pm.customFields))];
      }),
      switchMap((registration: any) => {
        const obvs = this.ndas.map((nda) => {
          return this.loadNda(nda);
        })
        // Promise.all(promises).then((pdfs) => {
        //   console.log('pdfs:', pdfs)
        //   this.ndaPdfs = pdfs
        // })
        return combineLatest(...obvs)
      })
    ).subscribe((pdfs) => {
      this.ndaPdfs = Object.assign({}, ...pdfs);
    }, err => {
      console.log('Error getting registration data: ', err);
      if (err && err.status === 401) {
        this.router.navigate(['/not-found']);
      }
    })

    // this.registrationService.getById(id).flatMap(
    //   registration => {
    //     if (registration.ndaSignature) {
    //       let urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i
    //       if (!urlRegex.test(registration.ndaSignature)) {
    //         registration.ndaSignature = JSON.parse(registration.ndaSignature)
    //         this.registration = registration;
    //         return this.registrationService.getNDAPDF(id)
    //       } else {
    //         this.registration = registration;
    //         return of(null)
    //       }
    //     } else {
    //       return of(null)
    //     }
    //   }).subscribe((resp) => {
    //     // if (resp && resp.id) {
    //     if (resp) {
    //     //   this.registration = resp;
    //     // } else {
    //       this.ndaPdf = `data:application/pdf;base64,${btoa(resp)}`;
    //     }
    //   },
    //   err => {
    //     console.log('Error getting registration data: ', err);
    //     if (err && err.status === 401) {
    //       this.router.navigate(['/not-found']);
    //     }
    //   }
    // );
  }

  public ngOnInit() {
    // remove
  }

  private loadNda(nda: any) {
    return this.ndaService.getPDF(nda.url).pipe(
      map((resp: ArrayBuffer) => {
        const pdfFile = new Blob([resp], { type: 'application/pdf' });
        return { [nda.url]: URL.createObjectURL(pdfFile) };
      })
    )
  }

  public downloadPDF() {
    let doc = new jsPDF();

    let specialElementHandlers = {
      '#editor': (element, renderer) => {
        return true;
      }
    };

    let container = this.container.nativeElement;
    console.log(container);

    // doc.fromHTML(container.innerHTML, 15, 15, {
    //   'width': 190,
    //   'elementHandlers': specialElementHandlers
    // });

    doc.html(document.body, {
      callback: () => {
        doc.save('nda.pdf');
      }
    });

    // doc.save('test.pdf');
  }

}
